<script>import Icon from '../Icon.svelte';
const iconNode = [["circle", { "cx": "12", "cy": "12", "r": "10" }], ["path", { "d": "m9 12 2 2 4-4" }]];
</script>

<Icon name="check-circle-2" {...$$props} iconNode={iconNode}>
  <slot/>
</Icon>
